export const isEllipsisActive = (elementId: string): boolean => {
  const inputElementRef = document.getElementById(elementId);
  return !!inputElementRef && inputElementRef.offsetWidth < inputElementRef.scrollWidth;
};
